/* hikerjoy · coșul lateral — „Produse recomandate” (snippets/hj-cart-reco.liquid, sections/hj-cart-auto.liquid).
   Varianta aleasă în card (preț, poză, link), „Adaugă” (un produs, apoi sertarul se redesenează prin renderContents al temei),
   completarea cu recomandările automate Shopify când regulile dau sub 2 produse (doar când sertarul e deschis)
   starea închis/deschis a listei, ținută pe durata sesiunii, și clasa hjc-cart-open pe <html> cât timp sertarul e deschis
   (ascunde bula de chat Shopify Inbox, din assets/hj-cart.css). */
(function () {
  if (window.hjCartInit) return;
  window.hjCartInit = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'hjc-closed';
  var cache = {};

  var fmt = function (c) {
    var s = (c / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lei';
  };
  var isClosed = function () { try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } };
  var remember = function (closed) { try { window.sessionStorage.setItem(KEY, closed ? '1' : '0'); } catch (e) { /* fără stocare */ } };

  var sync = function (card) {
    var s = card && card.querySelector('[data-hjc-select]');
    if (!s || s.selectedIndex < 0) return;
    var o = s.options[s.selectedIndex];
    var b = card.querySelector('[data-hjc-add]');
    if (b) b.setAttribute('data-id', o.value);
    var c = parseInt(o.getAttribute('data-price'), 10), pr = card.querySelector('[data-hjc-price]');
    if (pr && !isNaN(c)) pr.textContent = fmt(c);
    var img = card.querySelector('.hjc-card__img img'), src = o.getAttribute('data-img');
    if (img && src) { img.removeAttribute('srcset'); img.src = src; }
    var u = o.getAttribute('data-url');
    if (u) card.querySelectorAll('a[href]').forEach(function (a) { a.setAttribute('href', u); });
  };

  var topUp = function (box) {
    if (box.hasAttribute('data-hjc-done')) return;
    box.setAttribute('data-hjc-done', '');
    var pid = box.getAttribute('data-hjc-auto'), need = parseInt(box.getAttribute('data-hjc-need'), 10) || 0;
    var url = box.getAttribute('data-hjc-url') || root + 'recommendations/products';
    var list = box.querySelector('.hjc__list');
    if (!pid || need < 1 || !list || !window.fetch) return;
    if (!cache[pid]) {
      cache[pid] = fetch(url + '?section_id=hj-cart-auto&product_id=' + encodeURIComponent(pid) + '&limit=10&intent=related')
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var t = document.createElement('template');
          t.innerHTML = html;
          return [].map.call(t.content.querySelectorAll('.hjc-card'), function (li) { return li.outerHTML; });
        })
        .catch(function () { return []; });
    }
    cache[pid].then(function (cards) {
      if (!box.isConnected) return;
      var ex = box.getAttribute('data-hjc-ex') || ',', have = {}, added = 0;
      list.querySelectorAll('.hjc-card').forEach(function (li) { have[li.getAttribute('data-pid')] = true; });
      cards.forEach(function (h) {
        if (added >= need) return;
        var t = document.createElement('template');
        t.innerHTML = h;
        var li = t.content.firstElementChild, id = li && li.getAttribute('data-pid');
        if (!id || have[id] || ex.indexOf(',' + id + ',') > -1) return;
        have[id] = true;
        list.appendChild(li);
        added += 1;
      });
      if (list.querySelector('.hjc-card')) box.hidden = false;
    });
  };

  var scan = function () {
    var drawer = document.querySelector('cart-drawer');
    var open = !drawer || drawer.hasAttribute('open');
    document.querySelectorAll('[data-hjc]').forEach(function (box) {
      if (!box.hasAttribute('data-hjc-init')) {
        box.setAttribute('data-hjc-init', '');
        if (isClosed()) box.open = false;
        box.addEventListener('toggle', function () { remember(!box.open); });
      }
      if (open) topUp(box);
    });
  };

  document.addEventListener('change', function (e) {
    var s = e.target && e.target.closest ? e.target.closest('[data-hjc-select]') : null;
    if (s) sync(s.closest('.hjc-card'));
  });

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-hjc-add]') : null;
    if (!b) return;
    e.preventDefault();
    if (b.getAttribute('aria-disabled') === 'true' || !window.fetch) return;
    var card = b.closest('.hjc-card'), err = card ? card.querySelector('[data-hjc-err]') : null;
    var drawer = document.querySelector('cart-drawer');
    var sec = drawer && drawer.closest('.shopify-section');
    var secs = ['cart-icon-bubble'];
    if (sec) secs.push(sec.id.replace('shopify-section-', ''));
    b.setAttribute('aria-disabled', 'true');
    b.classList.add('is-loading');
    if (err) { err.hidden = true; err.textContent = ''; }
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(b.getAttribute('data-id'), 10), quantity: 1 }], sections: secs.join(','), sections_url: window.location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || '');
      if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) drawer.renderContents(res.data, true);
      else window.location.href = root + 'cart';
    }).catch(function (x) {
      if (err) { err.textContent = (x && x.message) ? x.message : 'Nu am putut adăuga produsul în coș. Încearcă din nou.'; err.hidden = false; }
    }).then(function () {
      b.removeAttribute('aria-disabled');
      b.classList.remove('is-loading');
    });
  });

  var init = function () {
    scan();
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || !window.MutationObserver) return;
    var html = document.documentElement;
    var mark = function () { html.classList.toggle('hjc-cart-open', drawer.hasAttribute('open')); };
    mark();
    var timer;
    new MutationObserver(function () {
      mark();
      clearTimeout(timer);
      timer = setTimeout(scan, 60);
    }).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();